export const PARCEL_STATUS = {
  ALL: 'ALL',
  PENDING: 'PENDING',
  ASSIGNED: 'ASSIGNED',
  PICKED_UP: 'PICKED_UP',
  IN_TRANSIT: 'IN_TRANSIT',
  DELIVERED: 'DELIVERED',
  COMPLETED: 'COMPLETED',
  DROPPED: 'DROPPED',
  CANCELLED: 'CANCELLED',
  FAILED: 'FAILED',
  RETURNED: 'RETURNED',
  OUT_FOR_DELIVERY: 'OUT_FOR_DELIVERY',
};

export const PARCEL_FILTERS = {
  MULTI_STAGE: 'MULTI_STAGE',
};

export const PARCEL_TYPE = {
  DOCUMENTS: { key: 'DOCUMENTS', label: 'Documents' },
  CLOTHES: { key: 'CLOTHES', label: 'Clothes' },
  ELECTRONICS: { key: 'ELECTRONICS', label: 'Electronics' },
  BOOKS: { key: 'BOOKS', label: 'Books' },
  OTHER: { key: 'OTHER', label: 'Other' },
  TOYS: { key: 'TOYS', label: 'Toys' },
  SHOES: { key: 'SHOES', label: 'Shoes' },
  MEDICINES: { key: 'MEDICINES', label: 'Medicines' },
  FOOD: { key: 'FOOD', label: 'Food' },
};

export const PARCEL_WEIGHT = {
  SMALL: { key: 'SMALL', label: 'Small (0-2kg)' },
  MEDIUM: { key: 'MEDIUM', label: 'Medium (2-5kg)' },
  LARGE: { key: 'LARGE', label: 'Large (5-10kg)' },
};
